import { useEffect } from 'react';

/**
 * Inyecta datos estructurados schema.org/FAQPage para que Google entienda el
 * bloque de preguntas frecuentes y pueda mostrarlo como resultado enriquecido.
 *
 * El array debe ser una constante estable (definida a nivel de módulo); si se
 * construye en cada render el script se recrearía en cada pasada.
 *
 * @param {Array<{q: string, a: string}>} questions
 */
export default function useFaqJsonLd(questions) {
  useEffect(() => {
    if (!questions || questions.length === 0) return undefined;

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: questions.map(({ q, a }) => ({
        '@type': 'Question',
        name: q,
        acceptedAnswer: { '@type': 'Answer', text: a },
      })),
    });
    document.head.appendChild(script);

    return () => script.remove();
  }, [questions]);
}
